//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import moment from 'moment-timezone';

import { ISchedulerDefaultPostingTime } from '@models/IUserSettings';

/**
 * Applies the minutes and hours from the given default time to the given date.
 */
export const applyDefaultTimeToDate = (
  date: Date,
  defaultTime: ISchedulerDefaultPostingTime,
): Date => {
  const dateMoment = moment(date);

  if (defaultTime.hour) {
    dateMoment.hours(defaultTime.hour);
  }

  if (defaultTime.minute) {
    dateMoment.minutes(defaultTime.minute);
  }

  return dateMoment.toDate();
};

/**
 * Extracts the minutes and hours from the given date to store as the default time.
 */
export const getDefaultTimeFromDate = (
  date: Date,
): ISchedulerDefaultPostingTime => {
  const dateMoment = moment(date);
  return {
    hour: dateMoment.hour(),
    minute: dateMoment.minute(),
  };
};
